module.exports = __webpack_public_path__ + "media/icons/info-2c7b5fcd.svg";